(function() {
    'use strict';

    // 色オプションのラベルを更新する
    function updateColorLabel(selectedInput) {
        const colorName = selectedInput.getAttribute('data-color-name');
        if (!colorName) return;

        // 同じvariant-wrapper内のラベルを検索
        const variantWrapper = selectedInput.closest('.variant-wrapper');
        if (variantWrapper) {
            const labelElement = variantWrapper.querySelector('[data-variant-color-label]');
            if (labelElement) {
            labelElement.textContent = colorName;
            }
        }
    }

    // バリアント入力の変更を監視
    function handleVariantChange(event) {
        const input = event.target;
        if (input.type === 'radio' && input.hasAttribute('data-color-name')) {
            updateColorLabel(input);
        }
    }

    // 初期化
    function init() {
        // 初期状態の設定
        const selectedColorInputs = document.querySelectorAll('input[data-color-name]:checked');
        selectedColorInputs.forEach(updateColorLabel);

        // イベントリスナー
        document.addEventListener('change', handleVariantChange);
        document.addEventListener('click', function(event) {
            const input = event.target;
            if (input.type === 'radio' && input.hasAttribute('data-color-name')) {
                setTimeout(() => updateColorLabel(input), 10);
            }
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
